module.exports = __webpack_public_path__ + "img/icon-chevron-circle.c5701f90.svg";